export default {
      id: "Vector-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#Vector",
      toString: function () {
        return this.url;
      }
    }